module.exports = __webpack_public_path__ + "media/icons/exclamation-circle-591eaf8e.svg";